<template>
    <b-modal
        id="preview-modal"
        no-fade
        scrollable
        hide-footer
        content-class="preview-modal-content"
    >
        <!-- modal header -->
        <template #modal-header>
            <div class="preview-modal--header w-100 row">
                <div
                    class="col col-md-2 preview-modal--close d-flex justify-content-start"
                >
                    <button
                        id="preview-modal--closebtn"
                        class="btn col-auto pointer py-2 item-settings-button"
                        @click="closeModal"
                    >
                        <b-tooltip
                            target="preview-modal--closebtn"
                            placement="bottom"
                        >
                            Voltar
                        </b-tooltip>
                        <i class="fal fa-chevron-left"></i>
                    </button>
                </div>

                <div
                    class="col col-md preview-modal--toolbar justify-content-center"
                >
                    <div>
                        <button
                            @click="activeView = 'desktop'"
                            id="desktop-btn"
                            type="button"
                            :class="[
                                'btn',
                                activeView === 'desktop' ? 'active' : ''
                            ]"
                        >
                            <i class="fal fa-desktop color-theme font-16"></i>
                        </button>

                        <button
                            @click="activeView = 'mobile'"
                            id="mobile-btn"
                            type="button"
                            :class="[
                                'btn',
                                activeView === 'mobile' ? 'active' : ''
                            ]"
                        >
                            <i class="fal fa-mobile color-theme font-16"></i>
                        </button>
                    </div>
                </div>

                <div
                    class="preview-modal--actions col col-md-2 d-flex p-0 justify-content-end align-items-center"
                >
                    <open-design-btn v-if="postIsPublished" :siteId="siteId" :postId="postId" />

                    <button
                        @click="savePost"
                        class="btn btn-primario py-2 px-4"
                    >
                        Salvar
                    </button>
                </div>
            </div>
        </template>

        <!-- conteudo da modal -->
        <b-overlay
            id="preview-modal--overlay"
            :show="!isLoaded"
            variant="dark"
            opacity="0.8"
            class="w-100 h-100 d-flex justify-content-center spinner-class"
        >
            <iframe
                @load="isLoaded = true"
                class="preview-modal--iframe w-100 h-100"
                :src="'//' + siteUrl + '/page/preview?preview=' + postId"
                allowfullscreen
                frameborder="0"
            />
        </b-overlay>
    </b-modal>
</template>

<script>
import Loading from '../Loading.vue';
import OpenDesignBtn from '../atoms/OpenDesignBtn.vue';

export default {
    name: "PreviewModal",
    components: {
        Loading,
        OpenDesignBtn,
    },
    data() {
        return {
            // controla o componente se está no modo mobile ou desktop
            activeView: "desktop",
            siteUrl: '',
            isLoaded: false,
        };
    },

    props: {
        postIsPublished: {
            type: Boolean,
            required: false,
        },
        postId: {
            required: true,
        },
        siteId: {
            type: Number,
            required: true,
        }
    },
    methods: {
        closeModal() {
            this.$bvModal.hide("preview-modal");
            this.isLoaded = false;
        },
        changeView(type) {
            const iframe = document.getElementsByClassName('preview-modal--iframe')[0];

            if (type == 'mobile') {
                iframe.classList.add('mobile');
            } else {
                iframe.classList.remove('mobile');
            }
        },
        savePost() {
            this.$emit('savePost');
        }
    },
    created() {
        this.siteUrl = JSON.parse(localStorage.siteData).url;
    },
    watch: {
        activeView(newVal) {
            if (newVal) {
                this.changeView(newVal);
            }
        }
    }
};
</script>

<style>
#preview-modal .item-settings-button {
    margin-left: 0;
    margin-right: 0;
    margin-top: 0;
}

#preview-modal > .modal-dialog {
    max-width: 100%;
    margin: 0;
}

.preview-modal-content {
    width: 100%;
    margin: 0;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100vh;
    display: flex;
}

.preview-modal--toolbar {
    display: none;
}

.preview-modal--toolbar i {
    color: var(--gray);
}

.preview-modal--toolbar button.active i {
    color: var(--main-color);
}

.preview-modal--actions #openDesignBtn + button {
    margin-left: 1.25rem;
}

.preview-modal--iframe.mobile {
    max-width: 414px!important;
}

.spinner-class {
    color: var(--main-color);
}

@media screen and (min-width: 576px) {
    .preview-modal--toolbar {
        display: flex;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/PreviewModal.vue